import { render, staticRenderFns } from "./ResumePlanDialog.vue?vue&type=template&id=01ffac90&scoped=true&"
import script from "./ResumePlanDialog.vue?vue&type=script&lang=js&"
export * from "./ResumePlanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffac90",
  null
  
)

/* custom blocks */
import block0 from "./ResumePlanDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
